module.exports = __webpack_public_path__ + "static/airmason_holly-98e86f2d9b99ba14bbd72364798ee045.png";